import { lockBody, unlockBody } from "@plugins";
import tippy from "tippy.js";

const sidebarConnection = document.querySelector(".js-sidebar-connection");

if (sidebarConnection) {
    const sidebarConnectionOpen = sidebarConnection.querySelector(".js-sidebar-connection-open");
    const sidebarConnectionClose = sidebarConnection.querySelector(".js-sidebar-connection-close");

    if (sidebarConnectionOpen && sidebarConnectionClose) {
        const buttons = [sidebarConnectionOpen, sidebarConnectionClose];

        for (const button of buttons) {
            button.addEventListener("click", () => {
                toggleModal();
            });
        }
    }

    initSidebarConnectionTooltips(sidebarConnection);
}

function toggleModal() {
    if (!sidebarConnection.classList.contains("active")) {
        openModal();
    } else {
        closeModal();
    }
}

function openModal() {
    sidebarConnection.classList.add("active");
    if (window.mobileMedia) {
        lockBody(document.body);
    }
}

function closeModal() {
    if (sidebarConnection.classList.contains("active")) {
        sidebarConnection.classList.remove("active");
        if (window.mobileMedia) {
            unlockBody(document.body);
        }
    }
}

function initSidebarConnectionTooltips(target) {
    const glossaryTooltips = target.querySelectorAll("[data-tooltip-target]");
    const readyToInitTooltips = [];

    if (glossaryTooltips && glossaryTooltips.length > 0) {
        for (const glossaryTooltip of glossaryTooltips) {
            if (glossaryTooltip.querySelector("[data-tooltip-content]")) {
                readyToInitTooltips.push(glossaryTooltip);
            }
        }

        tippy(readyToInitTooltips, {
            arrow: true,
            placement: "auto", // top, right, bottom, left
            trigger: "mouseenter click",
            interactive: true,

            allowHTML: true,
            hideOnClick: true,
            theme: "light",

            popperOptions: {
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            allowedAutoPlacements: ["top", "bottom"],
                        },
                    },
                ],
            },
            onCreate(instance) {
                instance.setContent(instance.reference.querySelector("[data-tooltip-content]"));
            },
            appendTo: () => document.body,
        });
    }
}
